import * as actions from './actions'

import type { CalendarPreference, Action } from './type'
import type { Program } from 'components/pages/analyticsPage/state/types'

export type State = {
  calendarPreferences: CalendarPreference;
  calendarUrl: string;
  programs: Program[];
  errors: any[];
  saving: boolean;
  saved: boolean;
  unsaved: boolean;
  initialLoad: boolean;
  displayCalendarDialog: boolean;
  displayCsvExportDialog: boolean;
};

export const initialState = {
  calendarPreferences: {},
  calendarUrl: '',
  programs: [],
  errors: [],
  saving: false,
  saved: false,
  unsaved: false,
  initialLoad: true,
  displayCalendarDialog: false,
  displayCsvExportDialog: false
} as const

const reducer = (state: State, action: Action) => {
// @ts-expect-error - TS2322 - Type '{ readonly calendarPreferences: {}; readonly calendarUrl: ""; readonly programs: readonly []; readonly errors: readonly []; readonly saving: false; readonly saved: false; readonly unsaved: false; readonly initialLoad: true; readonly displayCalendarDialog: false; readonly displayCsvExportDialog: false; }' is not assignable to type 'State'.
  if (state === undefined) { state = initialState }
  switch (action.type) {
// @ts-expect-error - TS2678 - Type '"API_CALENDAR_PREFERENCES_SHOW_SUCCESS"' is not comparable to type '"API_CALENDAR_PREFERENCES_SHOW"'. - fall through
    case actions.FETCH_CALENDAR_PREFERENCE_SUCCESS:
      return {
        ...state,
// @ts-expect-error - TS2339 - Property 'data' does not exist on type 'Action'. - fall through
        ...action.data,
        unsaved: false
      }
// @ts-expect-error - TS2678 - Type '"API_CALENDAR_PREFERENCES_UPDATE"' is not comparable to type '"API_CALENDAR_PREFERENCES_SHOW"'. - fall through
    case actions.SAVE_CALENDAR_PREFERENCE:
      return {
        ...state,
        saving: true,
        saved: false,
        unsaved: true,
        initialLoad: false
      }
// @ts-expect-error - TS2678 - Type '"API_CALENDAR_PREFERENCES_UPDATE_SUCCESS"' is not comparable to type '"API_CALENDAR_PREFERENCES_SHOW"'. - fall through
    case actions.SAVE_CALENDAR_PREFERENCE_SUCCESS:
      return {
        ...state,
// @ts-expect-error - TS2339 - Property 'data' does not exist on type 'Action'. - fall through
        ...action.data,
        saving: false,
        saved: true,
        unsaved: false,
        initialLoad: false,
        displayCalendarDialog: true
      }
// @ts-expect-error - TS2678 - Type '"API_CALENDAR_PREFERENCES_UPDATE_FAILURE"' is not comparable to type '"API_CALENDAR_PREFERENCES_SHOW"'. - fall through
    case actions.SAVE_CALENDAR_PREFERENCE_FAILURE:
      return {
        ...state,
        unsaved: true,
// @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'Action'. - fall through
        errors: action.errors,
        initialLoad: false,
        displayCalendarDialog: false
      }
// @ts-expect-error - TS2678 - Type '"UPDATE_CALENDAR_PREFERENCE"' is not comparable to type '"API_CALENDAR_PREFERENCES_SHOW"'. - fall through
    case actions.UPDATE_CALENDAR_PREFERENCE:
      return {
        ...state,
        saved: false,
        unsaved: true,
        initialLoad: false
      }
// @ts-expect-error - TS2678 - Type '"SET_CALENDAR_DIALOG_STATUS"' is not comparable to type '"API_CALENDAR_PREFERENCES_SHOW"'. - fall through
    case actions.SET_CALENDAR_DIALOG_STATUS:
      return {
        ...state,
// @ts-expect-error - TS2339 - Property 'value' does not exist on type 'Action'. - fall through
        displayCalendarDialog: action.value
      }
// @ts-expect-error - TS2678 - Type '"SET_CSV_EXPORT_DIALOG_STATUS"' is not comparable to type '"API_CALENDAR_PREFERENCES_SHOW"'. - fall through
    case actions.SET_CSV_EXPORT_DIALOG_STATUS:
      return {
        ...state,
// @ts-expect-error - TS2339 - Property 'value' does not exist on type 'Action'. - fall through
        displayCsvExportDialog: action.value
      }
    default:
      return state
  }
}

export default reducer
